import { GPTGameIcon } from './types';

export const WheelOfFortuneIcon: GPTGameIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    style={{ isolation: 'isolate' }}
    {...props}>
    <g className="origin-[14px_14px] animate-[spin_2s_linear_infinite] will-change-transform">
      <path
        d="M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z"
        fill="#A15EFF"
      />
      <path
        d="M14.0005 27.731C21.5839 27.731 27.7315 21.5835 27.7315 14C27.7315 6.41662 21.5839 0.269043 14.0005 0.269043C6.41711 0.269043 0.269531 6.41662 0.269531 14C0.269531 21.5835 6.41711 27.731 14.0005 27.731Z"
        fill="#8935FF"
      />
      <path
        d="M14.0003 26.3596C20.8264 26.3596 26.36 20.8259 26.36 13.9998C26.36 7.17377 20.8264 1.64014 14.0003 1.64014C7.17425 1.64014 1.64062 7.17377 1.64062 13.9998C1.64062 20.8259 7.17425 26.3596 14.0003 26.3596Z"
        fill="#742DD9"
      />
      <path
        d="M25.4363 10.9352C24.9173 8.99146 23.8956 7.15372 22.3708 5.62891L14 13.9997L25.4363 10.9356V10.9352Z"
        fill="#F8203D"
      />
      <path
        d="M14 14.0001L25.4363 17.0642C25.9716 15.0589 25.9716 12.9409 25.4363 10.9355L14 13.9997V14.0001Z"
        fill="white"
      />
      <path
        d="M14 13.9998L22.3708 5.62895C20.846 4.10414 19.0083 3.08246 17.0646 2.56348L14.0005 13.9998H14Z"
        fill="white"
      />
      <path
        d="M13.9997 14L10.9355 25.4363C12.9409 25.9716 15.0589 25.9716 17.0642 25.4363L14.0001 14H13.9997Z"
        fill="#F8203D"
      />
      <path
        d="M17.0646 25.4363C19.0083 24.9173 20.846 23.8956 22.3708 22.3708L14 14L17.0641 25.4363H17.0646Z"
        fill="white"
      />
      <path
        d="M5.62936 22.3708C7.15417 23.8956 8.99191 24.9173 10.9356 25.4363L13.9997 14L5.62891 22.3708H5.62936Z"
        fill="white"
      />
      <path
        d="M14 14L22.3708 22.3708C23.8956 20.846 24.9173 19.0083 25.4363 17.0646L14 14.0005V14Z"
        fill="#F8203D"
      />
      <path
        d="M13.9999 14.0001L2.56358 10.9355C2.02829 12.9409 2.02829 15.0589 2.56358 17.0642L13.9999 14.0001Z"
        fill="white"
      />
      <path
        d="M13.9997 13.9998L10.9352 2.56348C8.99146 3.08246 7.15372 4.10414 5.62891 5.62895L13.9997 13.9998Z"
        fill="white"
      />
      <path
        d="M5.62992 5.62891C4.10511 7.15372 3.08344 8.99146 2.56445 10.9352L14.0008 13.9993L5.62992 5.62891Z"
        fill="#F8203D"
      />
      <path
        d="M14.0008 14L2.56445 17.0641C3.08344 19.0078 4.10511 20.8455 5.62992 22.3703L14.0008 13.9995V14Z"
        fill="#F8203D"
      />
      <path
        d="M17.0642 2.56358C15.0589 2.02829 12.9409 2.02829 10.9355 2.56358L13.9997 13.9999L17.0638 2.56358H17.0642Z"
        fill="#F8203D"
      />
      <path
        d="M14.4213 1.20846C14.4825 0.97602 14.3437 0.737984 14.1112 0.676789C13.8788 0.615593 13.6408 0.754411 13.5796 0.986849C13.5184 1.21929 13.6572 1.45732 13.8896 1.51852C14.1221 1.57972 14.3601 1.4409 14.4213 1.20846Z"
        fill="white"
      />
      <path
        d="M14.0016 27.3372C14.242 27.3372 14.4368 27.1424 14.4368 26.902C14.4368 26.6616 14.242 26.4668 14.0016 26.4668C13.7613 26.4668 13.5664 26.6616 13.5664 26.902C13.5664 27.1424 13.7613 27.3372 14.0016 27.3372Z"
        fill="white"
      />
      <path
        d="M7.92562 2.60835C8.04563 2.81667 7.97453 3.0825 7.76621 3.20296C7.55789 3.32297 7.29206 3.25187 7.17159 3.04355C7.05158 2.83523 7.12268 2.5694 7.331 2.44894C7.53932 2.32893 7.80516 2.40003 7.92562 2.60835Z"
        fill="white"
      />
      <path
        d="M20.828 24.9555C20.948 25.1638 20.8769 25.4297 20.6686 25.5501C20.4602 25.6706 20.1944 25.599 20.0739 25.3907C19.9539 25.1824 20.025 24.9166 20.2333 24.7961C20.4417 24.6761 20.7075 24.7472 20.828 24.9555Z"
        fill="white"
      />
      <path
        d="M3.04355 7.17208C3.25187 7.29209 3.32297 7.55838 3.20296 7.7667C3.08295 7.97502 2.81667 8.04612 2.60835 7.92611C2.40003 7.8061 2.32893 7.53981 2.44894 7.33149C2.56895 7.12317 2.83523 7.05207 3.04355 7.17208Z"
        fill="white"
      />
      <path
        d="M25.1735 20.8865C25.4138 20.8865 25.6087 20.6917 25.6087 20.4513C25.6087 20.211 25.4138 20.0161 25.1735 20.0161C24.9331 20.0161 24.7383 20.211 24.7383 20.4513C24.7383 20.6917 24.9331 20.8865 25.1735 20.8865Z"
        fill="white"
      />
      <path
        d="M1.52133 14.0991C1.57654 13.8652 1.43166 13.6308 1.19773 13.5756C0.963801 13.5204 0.729403 13.6653 0.67419 13.8992C0.618978 14.1331 0.763858 14.3675 0.997789 14.4227C1.23172 14.4779 1.46612 14.3331 1.52133 14.0991Z"
        fill="white"
      />
      <path
        d="M27.2103 14.3073C27.3803 14.1373 27.3803 13.8617 27.2103 13.6918C27.0404 13.5218 26.7648 13.5218 26.5948 13.6918C26.4249 13.8617 26.4249 14.1373 26.5948 14.3073C26.7648 14.4772 27.0404 14.4772 27.2103 14.3073Z"
        fill="white"
      />
      <path
        d="M2.82583 20.8865C3.06619 20.8865 3.26104 20.6917 3.26104 20.4513C3.26104 20.211 3.06619 20.0161 2.82583 20.0161C2.58547 20.0161 2.39062 20.211 2.39062 20.4513C2.39062 20.6917 2.58547 20.8865 2.82583 20.8865Z"
        fill="white"
      />
      <path
        d="M24.956 7.17208C25.1643 7.05207 25.4302 7.12317 25.5506 7.33149C25.6706 7.53981 25.5995 7.80565 25.3912 7.92611C25.1829 8.04612 24.9171 7.97502 24.7966 7.7667C24.6766 7.55838 24.7477 7.29254 24.956 7.17208Z"
        fill="white"
      />
      <path
        d="M7.17159 24.9555C7.2916 24.7472 7.55789 24.6761 7.76621 24.7961C7.97453 24.9161 8.04563 25.1824 7.92562 25.3907C7.80561 25.599 7.53932 25.6701 7.331 25.5501C7.12268 25.4301 7.05158 25.1638 7.17159 24.9555Z"
        fill="white"
      />
      <path
        d="M20.5097 3.25632C20.7478 3.22386 20.9146 3.00449 20.8821 2.76633C20.8497 2.52817 20.6303 2.36142 20.3922 2.39387C20.154 2.42633 19.9872 2.6457 20.0197 2.88386C20.0522 3.12202 20.2715 3.28877 20.5097 3.25632Z"
        fill="white"
      />
    </g>
    <path
      d="M16.8384 14.1099C16.8384 15.5385 15.6808 16.6961 14.2522 16.6961C12.8236 16.6961 11.666 15.5385 11.666 14.1099C11.666 12.6813 14.2522 8.1665 14.2522 8.1665C14.2522 8.1665 16.8384 12.682 16.8384 14.1099Z"
      fill="#742DD9"
    />
    <path
      d="M15.5255 14.2274C15.6402 13.5243 15.1633 12.8613 14.4602 12.7466C13.7571 12.6318 13.094 13.1088 12.9793 13.8119C12.8645 14.515 13.3415 15.178 14.0446 15.2928C14.7477 15.4075 15.4107 14.9306 15.5255 14.2274Z"
      fill="white"
    />
  </svg>
);
